import { useState } from "react";
import { useNavigate, createSearchParams } from "react-router-dom";

export const useMobileNumberRegister = () => {
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [state, setState] = useState({
    fullName: "",
    fullNameStatus: "normal",
    fullNameErrorMessage: "",
    phoneNumber: "",
    phoneNumberStatus: "normal",
    phoneNumberErrorMessage: "",
  });

  const handleForms = (field) => (e) => {
    setState({
      ...state,
      [field]: e.target.value,
    });
  };

  const handleRegister = () => {
    if (!state.fullName || state.fullName.length < 5) {
      setState({
        ...state,
        fullNameStatus: "error",
        fullNameErrorMessage: "Full Name must consist of 5 characters",
      });

      return;
    }

    if (
      !state.phoneNumber ||
      state.phoneNumber.length < 10 ||
      state.phoneNumber.length > 13
    ) {
      setState({
        ...state,
        fullNameStatus: "normal",
        fullNameErrorMessage: "",
        phoneNumberStatus: "error",
        phoneNumberErrorMessage: "Mobile number must consist of 10-13 digit",
      });

      return;
    }

    setState({
      ...state,
      phoneNumberStatus: "normal",
      phoneNumberErrorMessage: "",
    });

    setShowModal(true);
  };

  const handleOTP = (method) => {
    navigate({
      pathname: "/verification/mobile-number",
      search: `?${createSearchParams({
        type: "register",
        method,
        phone: state.phoneNumber,
      })}`,
    });
  };

  return {
    showModal,
    setShowModal,
    state,
    handleForms,
    handleRegister,
    handleOTP,
  };
};
